<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">

  <div class="job-posts placements agreements margin-top-service-30px">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-left-0px padding-right-0px padding-bottom-0px">
      <div class="row">
        <div class="col-md-3 padding-right-0px colmd3">
          <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
            <div class="card height-100pe">

              <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
                <div class="row margin-top10px margin-left-20px  nav-link-hand">
                  <div class="col-md-10 padding-left-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Semen Analysis
                    </label>
                  </div>


                  <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                    <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                  </div>-->


                  <div class="col-md-1">
                    <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                  </div>
                  <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                  *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

                </div>




              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
                <div class="row border-top margin-left-0px margin-right-0px">
                  <div class="col-md-5 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                    <div class="date-form margin-top-5px form-group margin-bottom-0px">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div class="col-md-1 " (click)="DecrementDate()">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                  <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                </div>
                <div class="row   margin-right-0px margin-left-0px">
                  <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                  </div>
                  <div class="col-md-2" hidden>
                    <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Edit">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Delete">
                      <span class="badge font-size-14">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </div>

                </div>
                <div>
                  <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">

                    <!--<div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>
                    <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>-->
                    <div *ngIf="isRequesting">
                      <div class="loader-text">
                        <div class="loader-text2">

                          <div class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="margin-top-20px margin-left-5px">
                            <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                          </div>
                          <!--Loading Please Wait...-->
                        </div>
                      </div>
                      <!--<div class="loadernew"></div>-->


                    </div>
                    <div *ngIf="!isRequesting">
                      <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                        <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                          <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">



                        </div>
                        <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.OwnerName}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}} years,{{l.OwnerFormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-4">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                            </div>
                          </div>

                        </div>
                        <div class="col-md-3 padding-left-0px margin-top-5px">
                          <div class="text-align-center"><label class="font-size-12px">#{{l.CycleNo}}</label></div>
                          <div class="text-align-center">
                            <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                              <i class="fas fa-check-circle color-icon-completed font-size-16px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                              <i class="fas fa-check-circle color-gray font-size-16px">
                              </i>
                            </a>
                          </div>
                          <!--<div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="col-md-6 padding-left-17px padding-right-8px" *ngIf="ScanDetails">

          <div class="row" *ngIf="SelectedpatientDetails">
            <div class="col-md-12 padding-left-0px">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 ">
                      <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
                    </div>
                    <div class="col-md-4 margin-left-18">
                      <div class="row row-height-17px margin-left-0px">
                        <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.EggName}}</label>
                      </div>
                      <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>
                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->

                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggAgeYears}},{{SelectedpatientDetails.EggFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggTelephone1}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-3">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
                        </div>
                        <div class="col-md-9 padding-left-6px">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
                        </div>

                      </div>



                    </div>
                    <div class="col-md-6  padding-right-0px">
                      <!--<div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="SemanAnalysis2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SemanAnalysis2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                        </div>
                      </div>-->
                      <div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="SemanAnalysis2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SemanAnalysis2.ActivityStatus}}</label>
                        </div>
                      </div>
                      <div class="row margin-right-0px" hidden>
                        <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                        </div>
                        <div class="Dsa2" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                        </div>
                        <div class="Dsa3" *ngIf="DSADetails">

                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                        </div>

                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px">
                  <div class="card">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-6 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Semen Analysis
                          </label>
                        </div>
                        <div class="col-md-5  padding-right-0px">
                          <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                          <div class="row float-right" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">

                            <div class="col-md-11 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="SemenAnalysis()" title="Semen Analysis Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Semen Analysis Completed</a>
                            </div>

                            <!--<div class="offset-md-3 col-md-1 margin-top-3px padding-left-0px">

                            </div>
                            <div class="col-md-1">
                              <button type="button"
                                      class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                      name="upload">
                                <i class="fas fa-plus font-size-11"></i>
                              </button>
                            </div>-->
                            <div class="col-md-1" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printsource()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>

                          </div>

                          <div class="row" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.CycleType!=='IUI'">

                            <div class="col-md-10 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand patientreg-link float-right padding-top-5px font-weight-normal display-edit" (click)="SemenAnalysis()" title="Semen Analysis Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Semen Analysis Completed</a>
                            </div>

                            <!--<div class="offset-md-3 col-md-1 margin-top-3px padding-left-0px">

                            </div>
                            <div class="col-md-1">
                              <button type="button"
                                      class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                      name="upload">
                                <i class="fas fa-plus font-size-11"></i>
                              </button>
                            </div>-->

                            <div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printsourcedroplet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                              <!--<a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printsourcedroplet()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>-->
                            </div>
                          </div>

                          <div class="row" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.CycleType=='IUI'">

                            <div class="col-md-10 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="SemanAnalysis2">
                              <a class="nav-link-hand patientreg-link float-right padding-top-5px font-weight-normal display-edit" (click)="SemenAnalysisIUI()" title="Semen Analysis Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Semen Analysis Completed</a>
                            </div>

                            <!--<div class="offset-md-3 col-md-1 margin-top-3px padding-left-0px">

                            </div>
                            <div class="col-md-1">
                              <button type="button"
                                      class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                      name="upload">
                                <i class="fas fa-plus font-size-11"></i>
                              </button>
                            </div>-->

                            <div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printsourcedroplet()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                              <!--<a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printsourcedroplet()" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>-->
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class=" padding-lrt " data-ps-id="dfsfsde">
                      <div class="card-body">
                        <div *ngIf="SpermEndInfo && SemanAnalysis2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                          Source Details
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="SemanAnalysis2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Male Source </label>
                                          </div>


                                          <div class="col-md-3">
                                            <CodeTypeValue CodeType="IVFSP" (ngModelChange)="onChange2($event)" id="SpermEndInfo.SpermSource"
                                                           [(ngModel)]="SpermEndInfo.SpermSource" SelectedValue="SpermEndInfo.SpermSource"
                                                           name="SpermEndInfo.SpermSource" required>

                                            </CodeTypeValue>


                                          </div>
                                          <div class="col-md-3">
                                            <CodeTypeValue CodeType="IVSSF" (ngModelChange)="onChange($event)" id="SpermEndInfo.SpermSourceFrom"
                                                           [(ngModel)]="SpermEndInfo.SpermSourceFrom" SelectedValue="SpermEndInfo.SpermSourceFrom"
                                                           name="SpermEndInfo.SpermSourceFrom" required>

                                            </CodeTypeValue>


                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Source of Sperm  </label>
                                          </div>


                                          <div class="col-md-3">
                                            <CodeTypeValue CodeType="IVFSR" (ngModelChange)="onChange2($event)" id="SpermEndInfo.SpermSource"
                                                           [(ngModel)]="SpermEndInfo.SpermSource" SelectedValue="SpermEndInfo.SpermSource" required
                                                           name="SpermEndInfo.SpermSource">

                                            </CodeTypeValue>


                                          </div>
                                          <div class="col-md-3">
                                            <CodeTypeValue CodeType="IVSSF" (ngModelChange)="onChange($event)" id="SpermEndInfo.SpermSourceFrom"
                                                           [(ngModel)]="SpermEndInfo.SpermSourceFrom" SelectedValue="SpermEndInfo.SpermSourceFrom" required
                                                           name="SpermEndInfo.SpermSourceFrom">

                                            </CodeTypeValue>


                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row margin-top-5px" *ngIf="SelectedSource=='Frozen' && SelectedValue=='Donor'">
                                      <div class="col-md-3 text-align-right margin-top-4px">
                                        <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Select Donor</label>
                                      </div>
                                      <div class="col-md-4">
                                        <!--<input type="text" class="form-control" placeholder="Recommended Package">-->
                                        <label class="margin-top-7px font-size-12px margin-left-10px" *ngIf="patientName">{{patientName}}</label>

                                      </div>
                                      <div class="col-md-2 padding-left-0px margin-top-5px">
                                        <!--<div class="thick-circle4 nav-link-hand">
                                          <a>
                                            <i class="fas fa-ellipsis-h"></i>
                                          </a>
                                        </div>-->
                                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectDonorForEgg()"> <i class="fas fa-ellipsis-h"></i></button>
                                      </div>

                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Extraction Date </label>
                                          </div>


                                          <div class="col-md-3">

                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp2" [(ngModel)]="ExtractionDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d2.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Extraction Time </label>
                                          </div>


                                          <div class="col-md-3">

                                            <input type="text" class="form-control" id="SpermEndInfo.ExtractionTimeText" placeholder="Extraction Time"
                                                   [(ngModel)]="SpermEndInfo.ExtractionTimeText"
                                                   name="SpermEndInfo.ExtractionTimeText" #ExtractionTimeText="ngModel" />

                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Storage Location </label>
                                          </div>


                                          <div class="col-md-3">

                                            <input type="text" class="form-control" placeholder="Storage Location" id="SpermEndInfo.StorageLocationDetails"
                                                   [(ngModel)]="SpermEndInfo.StorageLocationDetails"
                                                   name="SpermEndInfo.StorageLocationDetails" #Size="ngModel"
                                                   maxlength="100">

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Technique </label>
                                          </div>




                                          <div class="col-md-5">
                                            <CodeTypeValue CodeType="IVFSR" id="SpermEndInfo.SpermRetrieval"
                                                           [(ngModel)]="SpermEndInfo.SpermRetrieval" SelectedValue="SpermEndInfo.SpermRetrieval"
                                                           name="SpermEndInfo.SpermRetrieval" required>

                                            </CodeTypeValue>


                                          </div>



                                        </div>


                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="SpermEndInfo && SemanAnalysis2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                          Source Details
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="SemanAnalysis2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Male Source </label>
                                          </div>


                                          <div class="col-md-3 margin-tg-auto">
                                            <!--<CodeTypeValue CodeType="IVFSP" (ngModelChange)="onChange2($event)" id="SpermEndInfo.SpermSource"
                                                           [(ngModel)]="SpermEndInfo.SpermSource" SelectedValue="SpermEndInfo.SpermSource"
                                                           name="SpermEndInfo.SpermSource" required>

                                            </CodeTypeValue>-->

                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.SpermSource}}</label>

                                          </div>
                                          <div class="col-md-3 margin-tg-auto">
                                            <!--<CodeTypeValue CodeType="IVSSF" (ngModelChange)="onChange($event)" id="SpermEndInfo.SpermSourceFrom"
                                                           [(ngModel)]="SpermEndInfo.SpermSourceFrom" SelectedValue="SpermEndInfo.SpermSourceFrom"
                                                           name="SpermEndInfo.SpermSourceFrom" required>

                                            </CodeTypeValue>-->

                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.SpermSourceFrom}}</label>

                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Source of Sperm  </label>
                                          </div>


                                          <div class="col-md-3 margin-tg-auto">
                                            <!--<CodeTypeValue CodeType="IVFSR" (ngModelChange)="onChange2($event)" id="SpermEndInfo.SpermSource"
                                                           [(ngModel)]="SpermEndInfo.SpermSource" SelectedValue="SpermEndInfo.SpermSource"
                                                           name="SpermEndInfo.SpermSource" required>

                                            </CodeTypeValue>-->

                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.SpermSource}} ({{SpermEndInfo.SpermSourceFrom}})</label>

                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Extraction Date </label>
                                          </div>


                                          <div class="col-md-3 margin-tg-auto">

                                            <!--<div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp2" [(ngModel)]="ExtractionDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d2.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>-->

                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.ExtractionDate | date:'MMM-dd-yyyy'}}</label>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Extraction Time </label>
                                          </div>


                                          <div class="col-md-3 margin-tg-auto">

                                            <!--<input type="time" class="form-control" id="CurrentSaveSpermDetailsRequest.ExtractionTime" placeholder="Extraction Time"
                                            [(ngModel)]="CurrentSaveSpermDetailsRequest.ExtractionTime"
                                            name="CurrentSaveSpermDetailsRequest.ExtractionTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->

                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.ExtractionTimeText}}</label>

                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Storage Location </label>
                                          </div>


                                          <div class="col-md-3 margin-tg-auto">

                                            <!--<input type="text" class="form-control" placeholder="Storage Location" id="SpermEndInfo.StorageLocationDetails"
                                            [(ngModel)]="SpermEndInfo.StorageLocationDetails"
                                            name="SpermEndInfo.StorageLocationDetails" #Size="ngModel"
                                            maxlength="100">-->

                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.StorageLocationDetails}}</label>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Technique </label>
                                          </div>




                                          <div class="col-md-5 margin-tg-auto">
                                            <!--<CodeTypeValue CodeType="IVFSR" id="SpermEndInfo.SpermRetrieval"
                                                           [(ngModel)]="SpermEndInfo.SpermRetrieval" SelectedValue="SpermEndInfo.SpermRetrieval"
                                                           name="SpermEndInfo.SpermRetrieval" required>

                                            </CodeTypeValue>-->

                                            <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.SpermRetrieval}}</label>

                                          </div>



                                        </div>


                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="SpermEndInfo && SemanAnalysis2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit2()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                          Processing
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="SemanAnalysis2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>

                                  </div>


                                </div>

                                <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-10 padding-right-0px">
                                            <div class="table-component">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">

                                                  <tr>

                                                    <!--<th class="font-weight-normal  background-primary">

                                                    </th>-->
                                                    <!--<th class="font-weight-normal td-padding-tb background-primary font-size-12px">
                                                      Occ
                                                    </th>-->
                                                    <!--<th class="font-weight-normal td-padding-tb background-primary font-size-12px">
                                                      Denuded
                                                    </th>-->












                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                                      Date of Sample Collection
                                                    </th>
                                                    <td class="td-padding-tb font-size-12px">
                                                      <div class="date-form">
                                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                               name="dp1" [(ngModel)]="DateofSampleCollection" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                                        <small class="form-text text-danger"
                                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                        </a>

                                                      </div>
                                                    </td>
                                                    <!--<td class="td-padding-tb font-size-12px">
                                                      <div class="date-form">
                                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                               name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                                        <small class="form-text text-danger"
                                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                        </a>

                                                      </div>
                                                    </td>-->
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                                      Time of Sample Collection
                                                    </th>
                                                    <td class="td-padding-tb font-size-12px">
                                                      <input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="SpermEndInfo.TimeOFSampleCollection" name="SpermEndInfo.TimeOFSampleCollection">
                                                      <ngx-material-timepicker #picker></ngx-material-timepicker>
                                                    </td>
                                                    <!--<td class="td-padding-tb font-size-12px"> <input type="time" class="form-control" placeholder="Time"></td>-->
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                                      Volume(ml)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Volume" id="SpermEndInfo.Volume"
                                                             [(ngModel)]="SpermEndInfo.Volume"
                                                             name="SpermEndInfo.Volume" #NeedleName="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"> <input type="number" class="form-control" placeholder="Volume"></td>-->
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                                      Count(mil/ml)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Count" id="SpermEndInfo.Count"
                                                             [(ngModel)]="SpermEndInfo.Count"
                                                             name="SpermEndInfo.Count" #Count="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Count"></td>-->
                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Motile Sperm Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Motility" id="SpermEndInfo.MotileSpermMotility"
                                                             [(ngModel)]="SpermEndInfo.MotileSpermMotility"
                                                             name="SpermEndInfo.MotileSpermMotility" #Count="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                                  </tr>

                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                                      Active Progressivemotility (%)
                                                    </th>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                      Total Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Active Progressivemotility" id="SpermEndInfo.ActiveProgressiveMotility"
                                                             [(ngModel)]="SpermEndInfo.ActiveProgressiveMotility"
                                                             name="SpermEndInfo.ActiveProgressiveMotility" #Count="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Progressive Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Progressive Motility" id="SpermEndInfo.ProgressiveMotility"
                                                             [(ngModel)]="SpermEndInfo.ProgressiveMotility"
                                                             name="SpermEndInfo.ProgressiveMotility" #ProgressiveMotility="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Non-Progressive Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Non-Progressive Motility" id="SpermEndInfo.NonProgressiveMotility"
                                                             [(ngModel)]="SpermEndInfo.NonProgressiveMotility"
                                                             name="SpermEndInfo.NonProgressiveMotility" #NonProgressiveMotility="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Immotile(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Immotile" id="SpermEndInfo.Immotile"
                                                             [(ngModel)]="SpermEndInfo.Immotile"
                                                             name="SpermEndInfo.Immotile" #Immotile="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Morphology(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Morphology" id="SpermEndInfo.Morphology"
                                                      [(ngModel)]="SpermEndInfo.Morphology"
                                                      name="SpermEndInfo.Morphology" #Morphology="ngModel"
                                                      maxlength="100" required>-->
                                                      <input type="number" class="form-control" placeholder="Morphology" id="SpermEndInfo.Morphology"
                                                             [(ngModel)]="SpermEndInfo.Morphology"
                                                             name="SpermEndInfo.Morphology" #Morphology="ngModel"
                                                             maxlength="100" required>
                                                      <!--<CodeTypeValue CodeType="IVFSM" id="SpermEndInfo.Morphology"
                                                      [(ngModel)]="SpermEndInfo.Morphology" SelectedValue="SpermEndInfo.Morphology"
                                                      name="SpermEndInfo.Morphology"></CodeTypeValue>-->
                                                    </td>

                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Cellular Debris
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <CodeTypeValue CodeType="IVFCD" id="SpermEndInfo.CellularDebris"
                                                                     [(ngModel)]="SpermEndInfo.CellularDebris" SelectedValue="SpermEndInfo.CellularDebris"
                                                                     name="SpermEndInfo.CellularDebris"></CodeTypeValue>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>-->
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Method of Preparation
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <CodeTypeValue CodeType="IVFMP" id="SpermEndInfo.MethodofPreparation"
                                                                     [(ngModel)]="SpermEndInfo.MethodOfPreparation" SelectedValue="SpermEndInfo.MethodOfPreparation"
                                                                     name="SpermEndInfo.MethodOfPreparation"></CodeTypeValue>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>-->
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Incubation Time (In Min)
                                                    </th>
                                                    <td class="td-padding-tb" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                                      <input type="number" class="form-control" placeholder="Incubation Time" id="SpermEndInfo.IncubationTime"
                                                             [(ngModel)]="SpermEndInfo.IncubationTime"
                                                             name="SpermEndInfo.IncubationTime" #IncubationTime="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <td class="td-padding-tb" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                      <CodeTypeValue CodeType="IVFIT" id="SpermEndInfo.IncubationTime"
                                                                     [(ngModel)]="SpermEndInfo.IncubationTime" SelectedValue="SpermEndInfo.IncubationTime"
                                                                     name="SpermEndInfo.IncubationTime"></CodeTypeValue>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Time"></td>-->
                                                  </tr>
                                                  <tr hidden>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Motile Sperm Count(mil/ml)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Sperm Count" id="SpermEndInfo.MotileSpermCount"
                                                             [(ngModel)]="SpermEndInfo.MotileSpermCount"
                                                             name="SpermEndInfo.MotileSpermCount" #MotileSpermCount="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Sperm Count"></td>-->
                                                  </tr>
                                                  <tr hidden>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="Motility" id="SpermEndInfo.Motility"
                                                             [(ngModel)]="SpermEndInfo.Motility"
                                                             name="SpermEndInfo.Motility" #Motility="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                                  </tr>



                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      DFI(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control" placeholder="DFI" id="SpermEndInfo.DFI"
                                                             [(ngModel)]="SpermEndInfo.DFI"
                                                             name="SpermEndInfo.DFI" #DFI="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="number" class="form-control" placeholder="Motility"></td>-->
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Notes
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="text" class="form-control" placeholder="Notes" id="SpermEndInfo.Notes"
                                                             [(ngModel)]="SpermEndInfo.Notes"
                                                             name="SpermEndInfo.Notes" #Notes="ngModel"
                                                             maxlength="100" required>
                                                    </td>
                                                    <!--<td class="td-padding-tb"><input type="text" class="form-control" placeholder="Notes"></td>-->
                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Slide Observed?
                                                    </th>
                                                    <td class="td-padding-tb"><input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="SpermEndInfo.SlideObserved" name="SpermEndInfo.SlideObserved"></td>
                                                    <!--<td class="td-padding-tb"><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>-->
                                                  </tr>
                                                </table>

                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>


                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="SpermEndInfo && SemanAnalysis2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit2()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="SemanAnalysis2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                          Processing
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="SemanAnalysis2">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>

                                  </div>


                                </div>

                                <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-10 padding-right-0px">
                                            <div class="table-component">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">

                                                  <tr></tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                                      Date of Sample Collection
                                                    </th>
                                                    <td class="td-padding-tb font-size-12px">
                                                      <!--<div class="date-form">
                                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                               name="dp1" [(ngModel)]="DateofSampleCollection" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                                        <small class="form-text text-danger"
                                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                        </a>

                                                      </div>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.DateofSampleCollection | date:'MMM-dd-yyyy'}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                                      Time of Sample Collection
                                                    </th>
                                                    <td class="td-padding-tb font-size-12px">
                                                      <!--<input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="SpermEndInfo.TimeOFSampleCollection" name="SpermEndInfo.TimeOFSampleCollection">
                                                      <ngx-material-timepicker #picker></ngx-material-timepicker>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.TimeOFSampleCollection| slice:11}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                                      Volume(ml)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Volume" id="SpermEndInfo.Volume"
                                                             [(ngModel)]="SpermEndInfo.Volume"
                                                             name="SpermEndInfo.Volume" #NeedleName="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Volume}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal  background-primary font-size-12px">
                                                      Count(mil/ml)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Count" id="SpermEndInfo.Count"
                                                             [(ngModel)]="SpermEndInfo.Count"
                                                             name="SpermEndInfo.Count" #Count="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Count}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Motile Sperm Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Motility" id="SpermEndInfo.MotileSpermMotility"
                                                             [(ngModel)]="SpermEndInfo.MotileSpermMotility"
                                                             name="SpermEndInfo.MotileSpermMotility" #Count="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.MotileSpermMotility}}</label>
                                                    </td>

                                                  </tr>

                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                                      Active Progressivemotility (%)
                                                    </th>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                      Total Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Active Progressivemotility" id="SpermEndInfo.ActiveProgressiveMotility"
                                                             [(ngModel)]="SpermEndInfo.ActiveProgressiveMotility"
                                                             name="SpermEndInfo.ActiveProgressiveMotility" #Count="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.ActiveProgressiveMotility}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Progressive Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Progressive Motility" id="SpermEndInfo.ProgressiveMotility"
                                                             [(ngModel)]="SpermEndInfo.ProgressiveMotility"
                                                             name="SpermEndInfo.ProgressiveMotility" #ProgressiveMotility="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.ProgressiveMotility}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Non-Progressive Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Non-Progressive Motility" id="SpermEndInfo.NonProgressiveMotility"
                                                             [(ngModel)]="SpermEndInfo.NonProgressiveMotility"
                                                             name="SpermEndInfo.NonProgressiveMotility" #NonProgressiveMotility="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.NonProgressiveMotility}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Immotile(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Immotile" id="SpermEndInfo.Immotile"
                                                             [(ngModel)]="SpermEndInfo.Immotile"
                                                             name="SpermEndInfo.Immotile" #Immotile="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Immotile}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Morphology(%)
                                                    </th>
                                                    <td class="td-padding-tb">

                                                      <!--<input type="number" class="form-control" placeholder="Morphology" id="SpermEndInfo.Morphology"
                                                             [(ngModel)]="SpermEndInfo.Morphology"
                                                             name="SpermEndInfo.Morphology" #Morphology="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Morphology}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Cellular Debris
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<CodeTypeValue CodeType="IVFCD" id="SpermEndInfo.CellularDebris"
                                                                     [(ngModel)]="SpermEndInfo.CellularDebris" SelectedValue="SpermEndInfo.CellularDebris"
                                                                     name="SpermEndInfo.CellularDebris"></CodeTypeValue>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.CellularDebris}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Method of Preparation
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<CodeTypeValue CodeType="IVFMP" id="SpermEndInfo.MethodofPreparation"
                                                                     [(ngModel)]="SpermEndInfo.MethodOfPreparation" SelectedValue="SpermEndInfo.MethodOfPreparation"
                                                                     name="SpermEndInfo.MethodOfPreparation"></CodeTypeValue>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.MethodOfPreparation}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Incubation Time (In Min)
                                                    </th>
                                                    <td class="td-padding-tb" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                                      <!--<input type="number" class="form-control" placeholder="Incubation Time" id="SpermEndInfo.IncubationTime"
                                                             [(ngModel)]="SpermEndInfo.IncubationTime"
                                                             name="SpermEndInfo.IncubationTime" #IncubationTime="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.IncubationTime}}</label>
                                                    </td>
                                                    <td class="td-padding-tb" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                      <!--<CodeTypeValue CodeType="IVFIT" id="SpermEndInfo.IncubationTime"
                                                                     [(ngModel)]="SpermEndInfo.IncubationTime" SelectedValue="SpermEndInfo.IncubationTime"
                                                                     name="SpermEndInfo.IncubationTime"></CodeTypeValue>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.IncubationTime}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr hidden>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Motile Sperm Count(mil/ml)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Sperm Count" id="SpermEndInfo.MotileSpermCount"
                                                             [(ngModel)]="SpermEndInfo.MotileSpermCount"
                                                             name="SpermEndInfo.MotileSpermCount" #MotileSpermCount="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.MotileSpermCount}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr hidden>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Motility(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="Motility" id="SpermEndInfo.Motility"
                                                             [(ngModel)]="SpermEndInfo.Motility"
                                                             name="SpermEndInfo.Motility" #Motility="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Motility}}</label>
                                                    </td>

                                                  </tr>



                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      DFI(%)
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control" placeholder="DFI" id="SpermEndInfo.DFI"
                                                             [(ngModel)]="SpermEndInfo.DFI"
                                                             name="SpermEndInfo.DFI" #DFI="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.DFI}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Notes
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="text" class="form-control" placeholder="Notes" id="SpermEndInfo.Notes"
                                                             [(ngModel)]="SpermEndInfo.Notes"
                                                             name="SpermEndInfo.Notes" #Notes="ngModel"
                                                             maxlength="100" required>-->
                                                      <label class="font-size-12px margin-bottom-0px">{{SpermEndInfo.Notes}}</label>
                                                    </td>

                                                  </tr>
                                                  <tr *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                                    <th rowspan="1" class=" font-weight-normal  background-primary font-size-12px">
                                                      Slide Observed?
                                                    </th>
                                                    <td class="td-padding-tb"><input type="checkbox" class="width-15px margin-top-10" [(ngModel)]="SpermEndInfo.SlideObserved" name="SpermEndInfo.SlideObserved"></td>

                                                  </tr>
                                                </table>

                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>


                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div>
                          <div *ngIf="SpermSourceInfo && SelectedpatientDetails.GradingModel=='Well Culture'">
                            <form class="form " novalidate="" (ngSubmit)="onSubmitStore()" #f="ngForm">
                              <div class="accordion margin-bottom-20px" id="accordionExample4">
                                <div class="card margin-bottom-5px">
                                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <h5 class="mb-0 height-24px">
                                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                            Storage
                                          </button>
                                        </h5>
                                      </div>
                                      <div class="col-md-8 " *ngIf="SemanAnalysis2">
                                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                        <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                      </div>
                                    </div>


                                  </div>

                                  <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                      <div class="row my-profile-form">
                                        <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                          <div class="row">
                                            <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Storage Type </label>
                                            </div>


                                            <div class="col-md-3">
                                              <CodeTypeValue CodeType="IVFSP"
                                                             id="SpermSourceInfo.StorageUnitType"
                                                             [(ngModel)]="SpermSourceInfo.StorageUnitType" SelectedValue="SpermSourceInfo.StorageUnitType"
                                                             name="SpermSourceInfo.StorageUnitType" required>

                                              </CodeTypeValue>


                                            </div>

                                          </div>


                                        </div>
                                      </div>
                                      <div class="row my-profile-form">
                                        <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                          <div class="row">
                                            <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Volume </label>
                                            </div>


                                            <div class="col-md-2">

                                              <input type="text" class="form-control" placeholder="Volume"
                                                     id="SpermSourceInfo.Volume"
                                                     [(ngModel)]="SpermSourceInfo.Volume"
                                                     name="SpermSourceInfo.Volume" #Endometrium="ngModel"
                                                     maxlength="100" required>
                                              <small class="form-text text-danger"
                                                     *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                                              <small class="form-text text-danger"
                                                     *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(special characters are not allowed)</small>

                                            </div>
                                            <div class="col-md-2">
                                              <CodeTypeValue CodeType="SEVU"
                                                             id="SpermSourceInfo.VolumeUnits"
                                                             [(ngModel)]="SpermSourceInfo.VolumeUnits" SelectedValue="SpermSourceInfo.VolumeUnits"
                                                             name="SpermSourceInfo.VolumeUnits">
                                              </CodeTypeValue>


                                            </div>
                                          </div>


                                        </div>
                                      </div>
                                      <div class="row my-profile-form">
                                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-3 padding-right-0px text-align-right">
                                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Details</label>
                                            </div>

                                            <div class="col-md-4 padding-right-0px">
                                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Details"
                                                        name="SpermSourceInfo.StorageUnitDetails"
                                                        [(ngModel)]="SpermSourceInfo.StorageUnitDetails" required minlength="1" maxlength="100"
                                                        #addconcerns_text="ngModel"></textarea>
                                              <small class="form-text text-danger"
                                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                                            </div>
                                          </div>


                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 padding-left-0px background-white" *ngIf="ScanDetails">
          <div class="row">
            <div class="position-fixed-Activities">

              <div class="col-md-12">
                <div class="card">
                  <div class="card-header wh-header  padding-left-0px padding-right-0px border-bottom-0px padding-top-0px">
                    <ul class="nav nav-tabs nav-tab-ivf margin-top-3px" id="tabContent">
                      <li class="active nav-link-hand margin-right-5px"><a class="nav-item-ivf active" href="#details" data-toggle="tab">Activities</a></li>
                      <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#access-security" data-toggle="tab">Forms</a></li>

                    </ul>
                  </div>
                  <div class="card-body padding-all-0px">
                    <div class="tab-content">
                      <div class="tab-pane active" id="details">
                        <!--<div class="card">
                          <div class="card-body padding-all-0px">
                            <div class="row margin-right-0px margin-left-0px margin-top-5px">
                              <div class="col-md-9 margin-left-15px padding-right-0px padding-left-0px ">
                                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                              </div>
                              <div class="col-md-2">
                                <button type="button"  class="btn btn-ivf-new  btn-sm background-primary border-all-secondary" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>
                              </div>
                            </div>

                            <div class="row margin-top-10 margin-left-0px">
                              <div class="col-md-12">
                                <div class="table-component">
                                  <div class="table-responsive overflow-x">


                                    <table class="table table-striped margin-left-zero"
                                           cols="auto,2*,*,*,*,*,*,*">

                                      <thead class="">
                                        <tr>

                                          <th class="td-width-103px font-weight-normal td-padding-tb">
                                            Date
                                          </th>

                                          <th class="font-weight-normal td-padding-tb">
                                            Remarks
                                          </th>


                                          <th class="text-align-center font-weight-normal td-padding-tb">
                                            Status
                                          </th>











                                                            </tr>
                                                          </thead>

                                                          <tbody class="table-body">
                                                            <tr>

                                                              <td class="padding-right-0px td-padding-tb align-top font-size-12px">
                                                                13-JUN-19


                                                              </td>




                                          <td class="td-padding-tb">
                                            <div>Day 4 Grading</div>
                                            <div class="td-padding-tb td-elipsis2">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.</div>
                                          </td>

                                          <td class="td-padding-tb text-align-center align-top">
                                            <i class="fas fa-circle light-gray-badge nav-link-hand  ">
                                            </i>
                                          </td>

                                        </tr>

                                      </tbody>

                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>-->
                        <!--<cycleactivities [ActorCode]="SelectedpatientDetails.EggSourceActorCode" [CycleCode]="SelectedpatientDetails.CycleActivity"></cycleactivities>-->
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                          <cycleactivities [ActorCode]="SelectedpatientDetails.EggSourceActorCode" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" ActivityName="ETREC" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='Self'">
                          <cycleactivities [ActorCode]="SelectedpatientDetails.EggSourceActorCode" [CycleCode]="SelectedpatientDetails.TreatmentCycleCode" ActivityName="ETSelf" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>
                      </div>
                      <div class="tab-pane" id="access-security">
                        <div class="card">
                          <div class="card-body padding-bottom-0px padding-top-0px">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                    <div class="row">


                                      <div class="col-md-12">
                                        <CustomDataByRequestType RequestedType="FDActorReports" ActorCode={{ActorCodeLoad()}}
                                                                 id="CurrentFdActorReportsDocController.TemplateName" SelectedValue=""
                                                                 [(ngModel)]="SelectedReport"
                                                                 (keyChange)="onAssignedToActorCode($event)"
                                                                 name="CurrentFdActorReportsDocController.TemplateName">
                                        </CustomDataByRequestType>
                                        <!--<CodeTypeValue CodeType="RELTP"></CodeTypeValue>-->


                                      </div>
                                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                        <div *ngIf="fo && fo.AutoSections" class="margin-top-10">


                                          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let section of  fo.AutoSections;let RowIndex = index">
                                            <div [id]="'accordion'+RowIndex">
                                              <div [ngSwitch]="section.SectionType">
                                                <div class="card-header wh-header font-size-16px  padding-top-0px padding-bottom-0px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                                                  <h5 class="mb-0">
                                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                                            aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                                                      {{section.Data.Title}}

                                                    </button>
                                                  </h5>

                                                </div>
                                                <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                                                     [attr.data-parent]="'#accordion'+RowIndex">
                                                  <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                                                    <div class="row" *ngSwitchCase="'AttrVal'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px" *ngFor="let field of  section.Fields">


                                                        <div [ngSwitch]="field.Data.ValueType">
                                                          <div class="row" *ngSwitchCase="'Bool'">
                                                            <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data"
                                                                           mode="view2">
                                                            </auto-gen-bool>
                                                          </div>
                                                          <div class="row" *ngSwitchCase="'List'">
                                                            <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data"
                                                                           mode="view2">
                                                            </auto-gen-list>
                                                          </div>
                                                          <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                                                            <auto-gen-text class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-text>
                                                          </div>
                                                          <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                                                            <auto-gen-cvs class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-cvs>
                                                          </div>
                                                          <div class="row" *ngSwitchCase="'Date'">
                                                            <auto-gen-date class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-date>
                                                          </div>
                                                          <div class="row padding-bottom-10px" *ngSwitchCase="'Grid'">
                                                            <!--<label>Grid: {{field.Title}}</label>-->
                                                            <auto-gen-grid class="col-md-12" [field]="field" mode="view2"></auto-gen-grid>
                                                          </div>

                                                          <div class="row" *ngSwitchDefault>




                                                          </div>





                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row" *ngSwitchCase="'Text'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px">
                                                        <!--*ngFor="let field of  section.Fields"-->

                                                        <div class="row">
                                                          <div class="col-md-12 " *ngFor="let field of section.Data.Fields">
                                                            <div class="row" *ngIf="field.ValueType=='Text'">

                                                              <div class="col-md-11 padding-left-0px padding-right-0px">

                                                                <textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" placeholder="Remarks"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          [(ngModel)]="field.Value" maxlength="600"></textarea>

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row" *ngSwitchCase="'Image'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px">
                                                        <!--*ngFor="let field of  section.Fields-->

                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <div class="table-component">
                                                              <div class="table-responsive">


                                                                <table class="table table-striped margin-left-zero">

                                                                  <!--<thead class="">
                                                                    <tr>
                                                                      <th class="min-width-0px width-57px padding-top-4px padding-bottom-4px"></th>

                                                                      <th class="width-53px padding-top-4px padding-bottom-4px">#</th>
                                                                      <th class="width-178px padding-top-4px padding-bottom-4px">Title</th>
                                                                      <th class="padding-top-4px padding-bottom-4px">Image</th>

                                                                      <th class="padding-top-4px padding-bottom-4px">Comments</th>
                                                                      <th class="padding-top-4px padding-bottom-4px"></th>
                                                                    </tr>
                                                                  </thead>-->
                                                                  <tbody class="table-body">

                                                                    <tr *ngFor="let field of section.Data.Fields; let RowIndex = index ">
                                                                      <!--<td class="padding-top-0px padding-bottom-0px ">

                                                                        <input type="checkbox" [(ngModel)]="field.IsSelected" />
                                                                        <i class="input-helper"></i>

                                                                      </td>-->
                                                                      <td class="padding-top-0px padding-bottom-0px ">{{RowIndex+1}}</td>

                                                                      <td class="padding-top-0px padding-bottom-0px ">
                                                                        <!--<input class="form-control " [(ngModel)]="field.Title" type="text" [ngModelOptions]="{standalone: true}" />-->
                                                                        <div><label class="margin-bottom-0px">{{field.Title}}</label></div>
                                                                        <div><label class="margin-bottom-0px"> {{field.Remarks}}</label></div>
                                                                      </td>
                                                                      <td class="padding-top-0px padding-bottom-0px padding-left-5px">

                                                                        <!--<div *ngIf="!field.HasImage">
                                                                          <button class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save">
                                                                            <i class="fas fa-ellipsis-h"></i>
                                                                          </button>
                                                                        </div>-->
                                                                        <div *ngIf="field.HasImage">
                                                                          <img class="img-circle-56 font-size-12px" [src]="field.ImageFile" onError="this.src='dummy.jpg';">
                                                                          <!--<button type="button" class="btn  btn-sm button-new-health margin-top-left" tooltip="Add" (click)="openDocContent(field)" *ngIf="field?.IsSelected"><i class="fas fa-plus nav-link-hand"></i></button>-->

                                                                        </div>
                                                                      </td>
                                                                      <!--<td class="padding-top-0px padding-bottom-0px">

                                                                        {{field.Remarks}}

                                                                      </td>-->
                                                                      <!--<td class="text-align-right padding-top-0px padding-bottom-0px">

                                                                        <a class="nav-link-hand font-size-20px margin-left-10px" title="Remove" *ngIf="field?.IsSelected"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                                                                      </td>-->



                                                                    </tr>

                                                                  </tbody>

                                                                </table>

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <!--<label>{{f.Title}}</label>
                                                    <label class="margin-left-auto"></label>-->

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!--<div *ngFor="let l of CurrentFdActorReportsDocController">
                                              <label>{{l.TemplateName}}</label>
                                            </div>-->


                                          </div>

                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-





      </div>
    </div>

  </div>
  <div class="row" *ngIf="Showivf">
    <div class="col-md-12">
      <ivfworkbench></ivfworkbench>
    </div>
  </div>
  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
